import React, { useContext } from "react"
import defaultGraveBanish from "../data/manual/grave-banish.json"

const GraveBanishCtx = React.createContext(null)

export const GraveBanishProvider = ({ children }) => {
  const [map, setMap] = React.useState(defaultGraveBanish)
  return (
    <GraveBanishCtx.Provider
      value={{
        map,
        setMap,
      }}
    >
      {children}
    </GraveBanishCtx.Provider>
  )
}

export const useGraveBanishCtx = () => {
  const data = useContext(GraveBanishCtx)
  if (!data) throw new Error("called context hook outside provider")
  return data
}
